import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=252f1873"
import script from "./sync.vue?vue&type=script&lang=js"
export * from "./sync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports